import React, { Children, cloneElement } from 'react'
import { MenuItem } from '../menu/menu'
import { IconClose, IconSelect } from '../icon/icon'
import { selectedText } from './grid-selection'

// Select mode in a list card's shared menu and status line (FleetGrid's
// `selection` and `selectActions`; the model is grid-selection.js). Nothing
// here knows what the rows are: the page hands its selection actions as
// MenuItems, each of which reads the selection itself.
//
// selectModeMenu({ selection, menu, actions }) -> the card's menu items:
//   not selecting  the page's menu, then "Select" (pinned: a header button);
//   selecting      the page's selection actions (pinned unless an item says
//                  otherwise), then "Done", then the page's unpinned items
//                  (the ⋮ keeps Recycle bin, Audit log, Table settings); the
//                  page's pinned buttons (Download, Mark all matching…) give
//                  way until Done.
// Without a selection the page's menu is as it was.
export const selectModeMenu = ({ selection, menu, actions }) => {
  const items = Children.toArray(menu)
  if (!selection) return items
  if (!selection.selecting) {
    return [...items, <MenuItem key="tb-select" Icon={IconSelect} text="Select" pin show onClick={selection.start} />]
  }
  const pinned = Children.toArray(actions).map(item => (item.props.pin === undefined ? cloneElement(item, { pin: true }) : item))
  const rest = items.filter(item => item && item.props && !item.props.pin)
  return [...pinned, <MenuItem key="tb-select-done" Icon={IconClose} text="Done" pin show onClick={selection.done} />, ...rest]
}

// The card's status line in select mode: how many are selected, and the two
// ways to change that at once -- "12 selected · Select all 340 matching ·
// Deselect all". "Select all matching" is offered while some row of all
// matching isn't selected (and only where the server takes "all matching");
// "Deselect all" while anything is. A page whose server takes ids only says
// the most it takes at once.
export const SelectionNotice = ({ selection }) => {
  if (!selection || !selection.selecting) return null
  const everything = selection.mode === 'matching' && !selection.ids.length
  const offerMatching = selection.canMatch && !everything && selection.total !== 0
  const matchingText = selection.total !== null ? `Select all ${selection.total.toLocaleString()} matching` : 'Select all matching'
  const capped = !selection.canMatch && Number.isFinite(selection.max) ? ` (at most ${selection.max.toLocaleString()} at once)` : ''
  return (
    <span className="tb-select-notice" role="status" data-testid="selection-notice">
      <span className="fw-semibold">{selectedText(selection)}{capped}</span>
      {offerMatching &&
        <>
          <span aria-hidden="true"> · </span>
          <button type="button" className="btn btn-link btn-sm p-0 align-baseline" onClick={selection.selectAllMatching}>{matchingText}</button>
        </>}
      {!selection.none &&
        <>
          <span aria-hidden="true"> · </span>
          <button type="button" className="btn btn-link btn-sm p-0 align-baseline" onClick={selection.deselectAll}>Deselect all</button>
        </>}
    </span>
  )
}
